// Simplified Australia outline as [longitude, latitude] pairs (clockwise from Cape York).
export const mainland: [number, number][] = [
  [142.5, -10.7], [143.5, -14], [145.3, -15], [146, -17], [146.3, -19], [148.8, -20.5],
  [150.5, -22.5], [151.5, -24], [153.2, -25.5], [153.6, -28.2], [153, -31], [152.5, -32.5],
  [151.3, -33.8], [150.2, -35.5], [150, -37.5], [147.5, -37.9], [146.3, -39], [144.5, -38.3],
  [143, -38.8], [141, -38.2], [139.8, -37.3], [139.3, -35.6], [138.1, -35.6], [137.5, -34],
  [136, -34.8], [135.2, -34.5], [134.2, -32.8], [132, -32], [129, -31.6], [126, -32.3],
  [124, -33], [122, -33.9], [119.5, -34.4], [118, -35], [116, -35], [115, -34.3],
  [115.6, -33.4], [115.7, -32], [115, -30], [114.6, -28.5], [113.5, -26.5], [113.8, -24],
  [113.7, -22.5], [114.6, -21.8], [116.7, -20.6], [119, -20], [121, -19.5], [122.3, -17.8],
  [123.6, -16.4], [125, -15], [126.8, -13.8], [128.2, -15], [129.5, -14.9], [130.2, -12.9],
  [131.5, -12.2], [132.6, -11.5], [134, -12], [135.8, -12.3], [136.8, -12.2], [136.5, -13.5],
  [135.5, -14.8], [137.5, -16], [139.3, -17.4], [140.8, -17.4], [141.5, -15], [141.6, -12.5],
]

export const tasmania: [number, number][] = [
  [144.6, -40.7], [148.3, -40.9], [148.3, -42.2], [147, -43.6], [146, -43.5], [145.2, -42.2],
]

export const perth: [number, number] = [115.86, -31.95]

// Logo-inspired dot colours, sampled across the map.
export const mapPalette = ['#FFDE00', '#99E425', '#12DBB4', '#3D05DD', '#6300FF']
